export default __webpack_public_path__ + "static/media/025-Shrimp.4a2f7e1e.svg";